import React from 'react';
import {
    AppstoreTwoTone,
} from '@ant-design/icons';
import { useAppState } from './AppStateProvider';
import { useAppSelector } from 'store/hooks';
import { selectOrderHasEnded } from 'store/order';

export const MenuIconComponent: React.FC = () => {
    const { showHideDrawer } = useAppState();
    const orderHasEnded: boolean = useAppSelector(selectOrderHasEnded);

    const showMenuOnClick = () => {
        showHideDrawer(true);
    };

    if (orderHasEnded) return null;

    return (
        <div id="menu"  onClick={showMenuOnClick} onMouseOver={showMenuOnClick}>
            <AppstoreTwoTone style={{ fontSize: 30 }} />
            <span>
                MENU
            </span>
        </div>
    );
};
export const MenuIcon = React.memo(MenuIconComponent);
